export default function ($context) {
    const $partCategoryInput = $context.find('.object-choose-radio:checked');
    const currentPartCategory = $partCategoryInput.attr('id');

    if (currentPartCategory === "category-claim-testing") {
        return 3;
    }

    return 6;
}
